module.exports = __webpack_public_path__ + "img/loan_market_logo.f1944e8a.png";